/* global process */
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import paypal from 'paypal-checkout'

import { withStyles } from '@mui/styles'
import { style } from 'styles'

function PayPal({ onConfirm, clientID, totalFee }) {
	const PayPalButton = paypal.Button.driver('react', { React, ReactDOM })
	const [button, setButton] = useState({
		visible: false,
	})
	const [transaction, setTransaction] = useState({
		complete: false,
		approved: false,
	})

	useEffect(() => {
		setTimeout(() => {
			setButton({
				visible: true,
			})
		}, 2000)
	}, [])

	const payment = (data, actions) => {
		return actions.payment.create({
			transactions: [
				{
					amount: { total: totalFee, currency: 'EUR' }
				}
			]
		})
	}

	const onAuthorize = async(data, actions) => {
		const paymentData = await actions.payment.execute()
		if (paymentData.state == 'approved' && paymentData.payer.status.toLowerCase() == 'verified') {
			// Verifico il pagamento
			const paymentCheck = await onConfirm(paymentData.id)
			setTransaction({
				completed: true,
				approved: true,
			})
			setButton({
				visible: false,
			})
		} else {
			setTransaction({
				completed: true,
				approved: false,
			})
			setButton({
				visible: false,
			})
		}
	}

	return (<div>
		<h4>Paga con PayPal</h4>
		<div style={{ display: button.visible ? 'block' : 'none' }}>
			<PayPalButton
				commit={ true }
				env={ process.env.NODE_ENV && process.env.NODE_ENV == 'production' ? 'production' : 'sandbox' }
				client={{
					sandbox: 'Ae9idkQyPxmw3SwkBaO_t38AeiSQyzSTzGFfMxKxklwWtcfO7VwWzyaOX7JxIWQjdIO1vQ9ESGrWggud',
					production: clientID,
				}}
				payment={ (data, actions) => payment(data, actions) }
				onAuthorize={ (data, actions) => onAuthorize(data, actions) }
			/>
		</div>
		{transaction.completed && <div>
			{transaction.approved && <p>Pagamento confermato</p>}
			{!transaction.approved && <p>Si è verificato un problema nel pagamento</p>}
		</div>}
	</div>)
}

export default withStyles(style)(PayPal)
